import React, { useState, useEffect } from 'react';
import { Grid, Button, Box, InputLabel, makeStyles } from '@material-ui/core';
import currentUserSelector from '../../../selectors/currentUserSelector';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserDetailsInSettings } from '../../../actions/get-user-details';
import { requestCurrentUser } from '../../../actions/users';
import Switch from '@material-ui/core/Switch';
import { createAction } from 'redux-actions';
import CancelModal from '../../../components/cancelModal';
import { cancelSubscription } from '../../../actions/cancelSubscription';
import { showSuccessSnackbar } from '../../../actions/snackbar';
import { requestSubscriptionStatus } from '../../../actions/subscription';

const useStyles = makeStyles({
    inputLabel: {
        color: '#08090a',
        fontSize: '0.875rem',
        fontWeight: '400',
        display: 'inline-flex !important',
        paddingLeft: '10px'
    }
});

export default function CancelForm() {
    const [error, setError] = React.useState({});
    const currentUser = useSelector(currentUserSelector);
    const dispatch = useDispatch();
    const [stripeStatus,setStripeStatus]=useState(null);
    const classes = useStyles();
    const isTooltipActive = useSelector(state => state?.currentUser?.user?.tooltip);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteProgress, setDeleleProgress] = useState(false);

    const cancelBrandDelete = () => {
        setDeleteModalOpen(false);
      }
    
      const onDeleteBrand = () => {
        setDeleleProgress(true);
        // call api to cancel subscription
        // dispatch(cancelSubscription()).then(data => {
        //     dispatch(showSuccessSnackbar('Subscription cancelled successfully!'))
        //   setDeleleProgress(false);
        //   setDeleteModalOpen(false);
        // }
        // );
        dispatch(cancelSubscription());
        setDeleleProgress(false);
        setDeleteModalOpen(false);
      }
      useEffect(() => {
        dispatch(requestSubscriptionStatus()).then(response => {
            if(response) {
             console.log("Stripe status>>>>>=", response?.payload?.data?.subscription_status)
                if(response?.payload?.data?.subscription_status=='past_due')
                {
                    setStripeStatus('Past Due');
                }
                else if(response?.payload?.data?.subscription_status=='active')
                {
                    setStripeStatus('Active');
                }
                else if(response?.payload?.data?.subscription_status=='canceled')
                {
                    setStripeStatus('Cancelled');
                }
                else{
                    setStripeStatus(null);
                }
            } else {
                console.log("error while fetching Stripe status>>>>>");
            }
        });
      }, [dispatch]);
    console.log("THE SUBSCRIPTION INFO",stripeStatus)
    
    return (<>
        <Grid container>
            <Grid item xs={12}>
                <Box pt={2} display="flex" flexDirection="row" justifyContent="center">
                {stripeStatus=='Cancelled'?
                <span>You have cancelled your subscription!!!</span>:
                <Button disableRipple variant="contained" color="primary" onClick={() =>  setDeleteModalOpen(true)} style={{ marginLeft: '0.5rem' }} autoFocus>
                                Cancel Subscription
                            </Button>
            }
                </Box>
            </Grid>
        </Grid>
        <CancelModal
        title={'Cancel Subscription ?'}
        loading={deleteProgress}
        content={`Are you sure, you want to cancel the subscription?`}
        onDelete={onDeleteBrand}
        isOpen={deleteModalOpen}
        onClose={() => cancelBrandDelete()} />
        </>
    )
}
